<template>
  <div class="columns is-multiline is-mobile">
    <div class="column is-half-desktop is-full-touch is-4-widescreen">
      <window title="Star Rating: (<a href='https://github.com/craigh411/vue-star-rating'>info</a>)" height="100%">
        <star-rating></star-rating>
      </window>
    </div>

    <div class="column is-half-desktop is-full-touch is-4-widescreen">
      <window title="Half Stars" height="100%">
        <star-rating :increment="0.5"></star-rating>
      </window>
    </div>

    <div class="column is-half-desktop is-full-touch is-4-widescreen">
      <window title="Bordered Stars" height="100%">
        <star-rating :border-width="3"></star-rating>
      </window>
    </div>

    <div class="column is-half-desktop is-full-touch is-4-widescreen">
      <window title="Red Stars" height="100%">
        <star-rating active-color="#9c0000"></star-rating>
      </window>
    </div>

    <div class="column is-half-desktop is-full-touch is-4-widescreen">
      <window title="Vibrant Stars" height="100%">
        <star-rating inactive-color="#e1bad9" active-color="#cc1166"></star-rating>
      </window>
    </div>

    <div class="column is-half-desktop is-full-touch is-4-widescreen">
      <window title="Small Stars" height="100%">
        <star-rating :star-size="20"></star-rating>
      </window>
    </div>

    <div class="column is-half-desktop is-full-touch is-4-widescreen">
      <window title="Big Stars" height="100%">
        <star-rating :star-size="60"></star-rating>
      </window>
    </div>

    <div class="column is-half-desktop is-full-touch is-4-widescreen">
      <window title="Fluid Stars" height="100%">
        <star-rating :increment="0.01" :fixed-points="2"></star-rating>
      </window>
    </div>

    <div class="column is-half-desktop is-full-touch is-4-widescreen">
      <window title="Preset Stars" height="100%">
        <star-rating :rating="4"></star-rating>
      </window>
    </div>

    <div class="column is-half-desktop is-full-touch is-4-widescreen">
      <window title="Non rounded start rating" height="100%">
        <star-rating :rating="4.67" :round-start-rating="false"></star-rating>
      </window>
    </div>

    <div class="column is-half-desktop is-full-touch is-4-widescreen">
      <window title="Read Only Stars" height="100%">
        <star-rating :rating="3.8" :read-only="true" :increment="0.01"></star-rating>
      </window>
    </div>

    <div class="column is-half-desktop is-full-touch is-4-widescreen">
      <window title="Lots of stars" height="100%">
        <star-rating :max-rating="10" :star-size="20"></star-rating>
      </window>
    </div>

    <div class="column is-half-desktop is-full-touch is-4-widescreen">
      <window title="RTL Stars" height="100%">
        <star-rating :rtl="true" :increment="0.5"></star-rating>
      </window>
    </div>

    <div class="column is-half-desktop is-full-touch is-4-widescreen">
      <window title="Style Rating" height="100%">
        <star-rating text-class="custom-text"></star-rating>
      </window>
    </div>

    <div class="column is-half-desktop is-full-touch is-4-widescreen">
      <window title="Hide Rating" height="100%">
        <star-rating :show-rating="false"></star-rating>
      </window>
    </div>

    <div class="column is-half-desktop is-full-touch is-4-widescreen">
      <window title="Inline Stars" height="100%">
        Rating: <star-rating :inline="true" :star-size="20" :read-only="true" :show-rating="false"
          :rating="5"></star-rating> by our customers.
      </window>
    </div>

    <div class="column is-half-desktop is-full-touch is-4-widescreen">
      <window title="Resetable stars with v-model (Vue 2.2+)" height="100%">
        <star-rating v-model="boundRating"></star-rating>
        <div style="padding-top:10px;cursor:pointer;margin-bottom:20px;color: blue;">
          <a @click="boundRating = 0;">Reset Rating</a>
        </div>
      </window>
    </div>

    <div class="column is-half-desktop is-full-touch is-4-widescreen">
      <window title="Capture Rating" height="100%">
        <star-rating :show-rating="false" @rating-selected="setRating"></star-rating>
        <div style="margin-top:10px;font-weight:bold;">{{rating}}</div>
      </window>
    </div>

    <div class="column is-half-desktop is-full-touch is-4-widescreen">
      <window title="Capture Mouse Over Rating" height="100%">
        <div @mouseleave="showCurrentRating(0)" style="display:inline-block;">
          <star-rating :show-rating="false" @current-rating="showCurrentRating"
            @rating-selected="setCurrentSelectedRating" :increment="0.5"></star-rating>
        </div>
        <div style="margin-top:10px;font-weight:bold;">{{currentRating}}</div>
      </window>
    </div>
  </div>
</template>

<script>
import StarRating from 'vue-star-rating';

export default {
  components: { 'star-rating': StarRating },
  methods: {
    setRating(rating) {
      this.rating = `You have Selected: ${rating} stars`;
    },
    showCurrentRating(rating) {
      this.currentRating =
        rating === 0
          ? this.currentSelectedRating
          : `Click to select ${rating} stars`;
    },
    setCurrentSelectedRating(rating) {
      this.currentSelectedRating = `You have Selected: ${rating} stars`;
    },
  },
  data() {
    return {
      rating: 'No Rating Selected',
      currentRating: 'No Rating',
      currentSelectedRating: 'No Current Rating',
      boundRating: 3,
    };
  },
};
</script>

<style scoped>
h2 {
  margin-bottom: 5px !important;
  margin-top: 25px;
}
</style>
